export class ConfiguracionSueldos{
    constructor(
        public aportPatroDep: Number,
        public aportPatroInd: Number,
    ){}
}